import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const agencyId = useHookstate<number | null>(null)
  const dispatchGroupId = useHookstate<number | null>(null)
  const deviceTypeId = useHookstate<number | null>(null)
  const forceRefresh = useHookstate(false)
  const station = useHookstate<string | null>(null)
  const vehicleTypeId = useHookstate<number | null>(null)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const vehicleFilter = [
    {
      name: 'vehicle',
      type: 'name',
      placeholder: 'Identification/Plate',
      variable: station,
    },
    {
      name: 'device_id',
      type: 'device_id',
      variable: deviceTypeId,
    },
    {
      name: 'vehicle_type_id',
      type: 'vehicle_type_id',
      variable: vehicleTypeId,
    },
    {
      type: 'agency_id',
      variable: agencyId,
    },
    {
      type: 'dispatch_group_id',
      variable: dispatchGroupId,
      dependent: agencyId,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="vehicle"
        title="Vehicles"
        disableColumnsFilters
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={vehicleFilter}
        clearFilters={() => {
          agencyId.set(null)
          dispatchGroupId.set(null)
          deviceTypeId.set(null)
          station.set('')

          forceRefresh.set(!forceRefresh.get())
        }}
        notSortable={[
          'dispatch_group:name',
          'agency:name',
          'vehicleType:name',
          'device:name',
        ]}
        forceOrderColumns={[
          'identification',
          'plate',
          'agency:name',
          'dispatch_group:name',
          'device:name',
          'vehicleType:name',
        ]}
        exceptColumns={[
          'vehicle_type_id',
          'agency_id',
          'device_id',
          'dispatch_group_id',
          'is_connected',
          'device_status_id',
          'brand',
          'imei',
          'model',
          'tracking_id',
          'task',
          'out_of_service',
          'acronym',
          'status',
        ]}
      />
    </Layout>
  )
}
